
  <section class="page-banner-sec"  [style.background-image]="'url(' + (pageData?.image ? pageData?.image  :'assets/img/how-it-work-page-banner.png') + ')'" >
    <div  class="container">
        <h1 class="page-banner-title">{{pageData?.title}}</h1>
    </div>
  </section>

  <section class="how-it-works-sec">

    <div class="container">
      <!-- <h2 class="site-title text-center mt-3 mb-4">How It Works</h2> -->
      <div class="mt-5"></div>
      <div class="custom-tabs appPreviewUl">
        <ul class="justify-content-start nav nav-pills mb-4">
          <li class="nav-item">
            <a href="javascript:void(0);" (click)='appPreview(1)'  class="nav-link"  [class.active]="appPreviewId==1">Customer App</a>
          </li>
          <li class="nav-item">
            <a href="javascript:void(0);" (click)='appPreview(2)' class="nav-link" [class.active]="appPreviewId==2">Driver App</a>
          </li>
        </ul>
      </div>



          <div *ngIf="appPreviewId==1">
            <div class="row">
              <div class="col-lg-6 order-lg-last">
                <div class="h-i-w-img" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="1100">
                  <img class="img-responsive" [src]="pageData?.jsonKey[0]?.customer[0]?.image? pageData?.jsonKey[0]?.customer[0]?.image: 'assets/img/howit-1.png'">
                </div>
              </div>
              <div class="col-lg-6">
                <div class="h-i-w-text h-i-w-text-1">
                  <h4 data-number="1">{{pageData?.jsonKey[0]?.customer[0]?.title}}</h4>
                  <p [innerHTML]="pageData?.jsonKey[0]?.customer[0]?.description"></p>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <div class="h-i-w-img" data-aos="fade-right" data-aos-easing="linear" data-aos-duration="1100">
                  <!-- <img class="img-responsive" [src]="pageData?.jsonKey[0]?.customer[1]?.image? pageData?.jsonKey[0]?.customer[1]?.image:'assets/img/howit-2.png'"> -->
                   <img class="img-responsive" src="assets/img/howit-2.png">
                </div>
              </div>
              <div class="col-lg-6">
                <img class="how-it-works-dots" src="assets/img/dots.png">
                <div class="h-i-w-text h-i-w-text-2">
                  <h4 data-number="2">{{pageData?.jsonKey[0]?.customer[1]?.title}}</h4>
                  <p [innerHTML]="pageData?.jsonKey[0]?.customer[1]?.description"></p>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6 order-lg-last">
                <div class="h-i-w-img" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="1100">
                  <!-- <img class="img-responsive" [src]="pageData?.jsonKey[0]?.customer[2]?.image? pageData?.jsonKey[0]?.customer[2]?.image:'assets/img/howit-3.png'"> -->
                  <img class="img-responsive" src="assets/img/howit-3.png">
                </div>
              </div>
              <div class="col-lg-6">
                <div class="h-i-w-text h-i-w-text-3">
                  <h4 data-number="3">{{pageData?.jsonKey[0]?.customer[2]?.title}}</h4>
                  <p [innerHTML]="pageData?.jsonKey[0]?.customer[2]?.description"></p>
                </div>
              </div>
            </div>
          </div>



          <div *ngIf="appPreviewId==2">
            <div class="row">
              <div class="col-lg-6 order-lg-last">
                <div class="h-i-w-img" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="1100">
                  <img class="img-responsive" [src]="pageData?.jsonKey[0]?.driver[0]?.image? pageData?.jsonKey[0]?.driver[0]?.image:'assets/img/howit-1.png'">
                </div>
              </div>
              <div class="col-lg-6">
                <div class="h-i-w-text h-i-w-text-1">
                  <h4 data-number="1">{{pageData?.jsonKey[0]?.driver[0]?.title}}</h4>
                  <p [innerHTML]="pageData?.jsonKey[0]?.driver[0]?.description"></p>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <div class="h-i-w-img" data-aos="fade-right" data-aos-easing="linear" data-aos-duration="1100">
                  <img class="img-responsive" [src]="pageData?.jsonKey[0]?.driver[1]?.image? pageData?.jsonKey[0]?.driver[1]?.image:'assets/img/howit-12.png'">
                </div>
              </div>
              <div class="col-lg-6">
                <div class="h-i-w-text h-i-w-text-2">
                  <h4 data-number="2">{{pageData?.jsonKey[0]?.driver[1]?.title}}</h4>
                  <p [innerHTML]="pageData?.jsonKey[0]?.driver[1]?.description"></p>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6 order-lg-last">
                <div class="h-i-w-img" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="1100">
                  <!-- <img class="img-responsive" [src]="pageData?.jsonKey[0]?.driver[2]?.image? pageData?.jsonKey[0]?.driver[2]?.image:'assets/img/howit-13.png'"> -->
                  <img class="img-responsive" src='assets/img/howit-13.png'>
                  howit-1.png
                </div>
              </div>
              <div class="col-lg-6">
                <div class="h-i-w-text h-i-w-text-3">
                  <h4 data-number="3">{{pageData?.jsonKey[0]?.driver[2]?.title}}</h4>
                  <p [innerHTML]="pageData?.jsonKey[0]?.driver[2]?.description"></p>
                </div>
              </div>
            </div>

          </div>



    </div>
  </section>

  <section class="about-we-live">
      <img class="pet-footprint" src="assets/img/pet-footprint.png">
      <div class="container">
        <img class="woman-calling" src="assets/img/woman-calling.png">
        <div class="about-we-live-text">
            <h2>We Are Live soon</h2>
            <!-- <p>Appropriately impact 2.0 applications whereas wireless process improvements.</p> -->
            <a class="btn btn-primary" [routerLink]="['/auth/signup']">Get Started</a>
        </div>

      </div>
  </section>


